import React from 'react';
import './cancel_refund.css'; // Assuming you'll use a single CSS file for both policies

const CancellationRefundPolicy = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Cancellation &amp; Refund Policy</h1>
      <p className="policy-last-updated">Last Updated: December 1, 2025</p>

      <section className="policy-section">
        <h2 className="section-title">1. Overview</h2>
        <p>At PrrepX Pathshala ("PrrepX Pathshala," "we," "us," or "our"), we strive to provide the best educational content and services. This policy outlines our guidelines for the cancellation of services and the processing of refunds.</p>
      </section>

      <section className="policy-section">
        <h2 className="section-title">2. Refund Eligibility (15-Day Guarantee)</h2>
        <p>We are committed to the quality of our offerings. Therefore, we provide a **15-day Money-Back Guarantee** on all our paid educational services. This includes:</p>
        <ul className="policy-list">
          <li>Paid Test Series subscriptions (current offering).</li>
          <li>All Paid Courses (e.g., recorded content, premium subscriptions).</li>
          <li>Future Paid Live Batches (online).</li>
          <li>Future Paid Offline Batches (classroom).</li>
        </ul>
        <p>A refund may be requested only if the request is submitted within **fifteen (15) calendar days** from the date of purchase or enrollment ("Purchase Date").</p>
      </section>

      <section className="policy-section">
        <h2 className="section-title">3. Non-Eligibility for Refund</h2>
        <p>A refund will **not** be granted in the following scenarios:</p>
        <ul className="policy-list">
          <li>The refund request is initiated after the 15-day period from the Purchase Date has expired.</li>
          <li>If a significant portion of the course, batch, or test series has been consumed (e.g., over 20% of the content viewed, or more than 3 test papers attempted in a series).</li>
          <li>If the user has downloaded course materials or test series content that is not publicly available.</li>
          <li>In cases where the service purchased is explicitly marked as "Non-Refundable" prior to purchase (e.g., certain promotional offers, trial packs).</li>
        </ul>
      </section>

      <section className="policy-section">
        <h2 className="section-title">4. Cancellation by PrrepX Pathshala</h2>
        <p>PrrepX Pathshala reserves the right to cancel or discontinue a course or batch due to unavoidable circumstances (e.g., instructor unavailability, low enrollment). In such cases, enrolled users will be offered a **full refund** or the option to transfer their enrollment to a similar course/batch.</p>
      </section>

      <section className="policy-section">
        <h2 className="section-title">5. Refund Process</h2>
        <ol className="policy-numbered-list">
          <li>To request a refund, please send an email to our contact email (as listed on our <a href="https://prrepxpathshala.live/enquiry-now" target="_blank" rel="noopener noreferrer">Enquiry Now</a> page) with the subject line: **"Refund Request - [Your Course Name/Test Series Name]"**.</li>
          <li>The email must include your registered name, email ID, phone number, date of purchase, and the reason for the refund request.</li>
          <li>We will review the request against the eligibility criteria (Section 2 & 3).</li>
          <li>Approved refunds will be processed within **7-14 business days** from the date of approval. The refund amount will be credited back to the original payment method used during the purchase.</li>
          <li>Email ID: support@prrepxpathshala.live  Contact Number: +918287648766(Only WhatsaApp)</li>
        </ol>
      </section>
    </div>
  );
};

export default CancellationRefundPolicy;